<template>
  <div class="account-boxes">
    <DeployerUiBox :box-title="box1.title">
      <DeployerAccountPlanSummary />

      <div class="buttons-row">
        <NuxtLink to="/account/plan/" class="btn grey-border">
          {{ box1.select_plan }}
        </NuxtLink>
        <NuxtLink to="/account/billing/" class="btn grey-border">
          {{ box1.update_payment }}
        </NuxtLink>
      </div>
    </DeployerUiBox>

    <DeployerUiBox :box-title="box2.title">
      <DeployerAccountQuickLinks />
    </DeployerUiBox>
  </div>
</template>

<script setup>
const textsStore = useTextsStore()
const box1 = computed(() => textsStore.account.general.box_1)
const box2 = computed(() => textsStore.account.general.box_2)
</script>

<style lang="scss" scoped></style>
